var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{staticClass:"zoox-component zoox-page-transition",attrs:{"name":_vm.type,"mode":"out-in"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }